import { customAlphabet } from "nanoid";

const defaultNanoIDAlphabet = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
const defaultNanoIDLength = 6;

export const createNanoID = (length?: number, characters?: string): string => {
	const nanoid = customAlphabet(characters || defaultNanoIDAlphabet, length || defaultNanoIDLength);
	return nanoid();
};
